import { api } from '@/utils/api';
import { useEffect, useState } from 'react';
import { ImageWithFallback } from './ui/fallbackImage';

interface ProfileLink {
  id: number;
  title: string;
  description: string;
  url: string;
  preview: string;
}

export default function LinksList({ profileId }: { profileId: number }) {
  const [links, setLinks] = useState<ProfileLink[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/profile/links?pid=${profileId}`);
        setLinks(data);
      } catch (err) {
        console.error('Error fetching links:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, [profileId]);

  if (loading) {
    return "";
  }

  return (
    <div className="max-w-3xl">
      <div className="space-y-4">
        <div className="flex flex-col gap-4">
          {links.map((link: ProfileLink) => (
            <div key={link.id} className="flex items-stretch gap-1 hover:scale-[102%]">
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full flex-1"
              >
                <div className="flex w-full flex-col overflow-hidden rounded-lg border bg-card shadow-lg transition-shadow duration-300 hover:shadow-xl sm:flex-row sm:items-center lg:max-h-32">
                  <div className="w-full sm:w-1/3">
                    <ImageWithFallback
                      src={link.preview || ''}
                      fallbackImage="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDov..."
                      alt="link thumbnail"
                      className="h-44 w-full rounded-lg object-cover sm:h-32"
                    />
                  </div>

                  <div className="flex flex-col p-2 text-left sm:w-2/3">
                    <h3 className="truncate text-lg font-semibold">{link.title}</h3>
                    <p className="mt-2 line-clamp-2 text-sm text-gray-600">{link.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
